export function judeEnv () {
  // 判断userAgent中是否拥有标识
  function matchUserAgent (reg) {
    return !!navigator.userAgent.match(reg)
  }
  function isMobileWeb () {
    var sUserAgent = navigator.userAgent.toLowerCase()
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      return true
    } else {
      return false
    }
  }
  // 是否从蜂巢进入
  function isFengChao () {
    let bool = false
    if (matchUserAgent(/CombWebView/)) {
      bool = true
    }
    return bool
  }
  // 判断是否是微信环境
  function getIsWxClient () {
    if (matchUserAgent(/MicroMessenger/i)) {
      return true
    }
    return false
  }

  const environment = {
    isMobie: false,
    isFengChao: false,
    isWeChat: false,
    isMobileWeb: false
  }
  if (isFengChao()) {
    environment.isFengChao = true
  } else {
    environment.isFengChao = false
  }
  if (getIsWxClient()) {
    environment.isWeChat = true
  } else {
    environment.isWeChat = false
  }
  if (isMobileWeb()) {
    environment.isMobileWeb = true
  } else {
    environment.isMobileWeb = false
  }
  return environment
}